import { Link } from 'react-router-dom'

const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/zene__ai?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
        <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6m9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61581768397314',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
        <path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14C17.17 2.09 16.06 2 14.92 2 12.2 2 10.5 3.7 10.5 6.61V9.5H8v4h2.5V22h3.5v-8.5Z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/zeneai/',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
        <path d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002ZM7 8.48H3V21h4V8.48Zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68Z" />
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@zene-ai',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
        <path d="M23.5 6.2a3.03 3.03 0 0 0-2.13-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.37.56A3.03 3.03 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3.03 3.03 0 0 0 2.13 2.14C4.5 20.5 12 20.5 12 20.5s7.5 0 9.37-.56a3.03 3.03 0 0 0 2.13-2.14A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8ZM9.75 15.5v-7l6.25 3.5-6.25 3.5Z" />
      </svg>
    ),
  },
] as const

const FOOTER_COLUMNS = [
  {
    title: 'Programs',
    nodeId: '975:2518',
    links: [
      { label: 'English AI', href: '/english-ai', nodeId: '975:2520' },
      { label: 'Code Monkey', href: '/code-monkey', nodeId: '975:2521' },
      { label: 'The Edge', href: '/the-edge', nodeId: '975:2522' },
    ],
  },
  {
    title: 'Company',
    nodeId: '975:2524',
    links: [
      { label: 'About Us', href: '/about', nodeId: '975:2526' },
      { label: 'Careers', href: '/careers', nodeId: '975:2527' },
      { label: 'Blogs', href: '/blog', nodeId: '975:2528' },
    ],
  },
  {
    title: 'Support',
    nodeId: '975:2530',
    links: [
      { label: 'Get in Touch', href: '/contact', nodeId: '975:2532' },
      { label: 'FAQs', href: '/faq', nodeId: '975:2533' },
      { label: 'Privacy Policy', href: '/privacy-policy', nodeId: '975:2534' },
    ],
  },
] as const

const bodyStyle = {
  fontSize: 'var(--footer-text-body)',
  fontVariationSettings: "'opsz' 14",
} as const

export function Footer() {
  return (
    <footer
      className="w-full bg-black text-white [&_a]:text-white [&_a:hover]:text-white [&_a]:transition-none"
      data-node-id="977:2019"
    >
      <div
        className="mx-auto w-full max-w-[var(--footer-content-max-w)] px-6 sm:px-10 lg:px-[var(--footer-padding-x)]"
        style={{
          paddingTop: 'var(--footer-padding-top)',
          paddingBottom: 'var(--footer-padding-bottom)',
        }}
        data-node-id="975:2514"
      >
        {/* Top section — brand + link columns */}
        <div className="footer-top flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          {/* Brand column */}
          <div className="footer-brand shrink-0">
            <a href="/" aria-label="Zene AI — Home" data-node-id="975:2515">
              <img
                src="/assets/figma/footer/logo.png"
                alt="Zene.ai"
                className="object-contain object-left"
                style={{
                  width: 'var(--footer-logo-w)',
                  height: 'var(--footer-logo-h)',
                }}
              />
            </a>
            <p
              className="capitalize font-body font-normal leading-normal text-white"
              style={{
                ...bodyStyle,
                maxWidth: 'var(--footer-tagline-max-w)',
                marginTop: 'var(--footer-tagline-gap)',
              }}
              data-node-id="975:2516"
            >
              AI-powered learning for future-ready students across India.
            </p>
            <div
              className="flex items-center gap-4"
              style={{ marginTop: 'var(--footer-tagline-gap)' }}
              aria-label="Social media"
            >
              {SOCIAL_LINKS.map(social => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="text-white opacity-90 transition-opacity hover:opacity-100"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          <div className="footer-link-columns flex flex-col gap-y-10 sm:flex-row sm:flex-wrap sm:gap-x-[var(--footer-col-gap)] sm:gap-y-10">
            {FOOTER_COLUMNS.map(column => (
              <div key={column.title}>
                <p
                  className="font-heading font-medium uppercase leading-none text-white"
                  style={{ fontSize: 'var(--footer-text-heading)' }}
                  data-node-id={column.nodeId}
                >
                  {column.title}
                </p>
                <ul
                  className="flex flex-col capitalize"
                  style={{
                    marginTop: 'var(--footer-heading-link-gap)',
                    gap: 'var(--footer-link-gap)',
                  }}
                >
                  {column.links.map(link => (
                    <li key={link.href}>
                      {link.href.startsWith('/') ? (
                        <Link
                          to={link.href}
                          className="font-body font-normal leading-normal text-white no-underline"
                          style={bodyStyle}
                          data-node-id={link.nodeId}
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <a
                          href={link.href}
                          className="font-body font-normal leading-normal text-white"
                          style={bodyStyle}
                          data-node-id={link.nodeId}
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <hr
          className="border-0 border-t border-white"
          style={{ marginTop: 'var(--footer-section-gap)' }}
          data-node-id="975:2535"
        />

        {/* Bottom bar */}
        <div
          className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
          style={{ marginTop: 'var(--footer-bottom-gap)' }}
        >
          <p
            className="capitalize font-body font-normal leading-normal text-white"
            style={bodyStyle}
            data-node-id="975:2536"
          >
            © 2026 Zene AI. All rights reserved.
          </p>
          <p
            className="capitalize font-body font-normal leading-normal text-white"
            style={bodyStyle}
            data-node-id="975:2537"
          >
            Designed by{' '}
            <a
              href="https://theories.consulting/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white underline decoration-solid underline-offset-2"
            >
              Theories consulting
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
